import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IAllergySnomed, IAttributes } from 'src/app/models/IAttributes';
import { CCDAAllergies, IAllergies } from 'src/app/models/IAllergies';
import { configuration } from 'src/environments/environment';
import { IMedicationMasterData } from 'src/app/models/IMedicationMasterData';
import { CCDAPatientMedication } from 'src/app/models/IPatientMedication';
import { ICSSubcategeories } from 'src/app/models/IChiefStatement';

@Injectable({
  providedIn: 'root'
})
export class AllergyService {

  constructor(private http: HttpClient) { }

  // Get allergy attributes by Id 
  // getAttributes(id): Observable<IAttributes[]> {
  //   return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/AllergyAttributesByType'}?attributeid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&FacilityId=${sessionStorage.getItem("FacilityId")}`);
  // }

  getAttributes(id): Observable<IAttributes[]> {
    const postdata = {
      FacilityId: sessionStorage.getItem("FacilityId"),
      attributeid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/AllergyAttributesByType'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // New Added Get Allergy
  // getAttributesbyAllergy(id): Observable<IMedicationMasterData[]> {
  //   return this.http.get<IMedicationMasterData[]>(`${configuration.clinicapiUrl + 'Master/NewAllergyAttributesByType'}?attributeid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&FacilityId=${sessionStorage.getItem("FacilityId")}`);
  // }

  // Get allergies by Encounter Id
  getAllergies(encId: string, type: number): Observable<IAllergies[]> {
    return this.http.get<IAllergies[]>(`${configuration.clinicapiUrl + 'Encounter/AllergiesInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encid=${encId}&&type=${type}`);
  }

  // Get all allergies by Encounter Id
  getAllAllergies(encId: string): Observable<IAllergies[]> {
    return this.http.get<IAllergies[]>(`${configuration.clinicapiUrl + 'Encounter/AllAllergiesInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encid=${encId}`);
  }

  // Add allergy to patient encounter
  addAllergyInfo(allergyDetailsInfo: IAllergies): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(allergyDetailsInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/InsertAllergies'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Add allergy attribute 
  addAllergyAttributeInfo(allergyAttributeDetailsInfo: IAttributes): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertAllergyAttributes'}?FacilityId=${sessionStorage.getItem("FacilityId")}`, allergyAttributeDetailsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Delete allergy by allergy Id
  deleteAllergyById(alergyDetailsInfo: IAllergies): Observable<string> {
    alergyDetailsInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString()
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/DeleteAllergy'}`, alergyDetailsInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Delete allergies by encounter Id
  deleteAllAllergies(encId: string, modified: string, type: number): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/DeleteAllergies'}?encid=${encId}&&modifiedby=${modified}&&type=${type}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Update allergy by allergy Id
  updateAllergy(alergyDetailsInfo: IAllergies): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(alergyDetailsInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/ModifyAllergies'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Review allergies
  reviewAllergies(type: number, encId: string, userId: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateReviewData'}?userId=${encodeURIComponent(userId).toString()}&&type=${type}&&encId=${encId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  copyPreviousAllergies(encId: string): Observable<IAllergies[]> {
    return this.http.get<IAllergies[]>(`${configuration.clinicapiUrl + 'Encounter/copyPreviousAllergies'}?encId=${encId}`);
  }

  // Delete allergies by NKA Checked value
  deleteNKAAllAllergies(encId: string, modified: string, type: number): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/DeleteNKACheckedValueAllergies'}?encid=${encId}&&modifiedby=${modified}&&type=${type}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //Get search Drug Allergies
  getAllDrugAllergyWithCodesBySearch(searchstr: string): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(
      `${configuration.clinicapiUrl + 'Encounter/DrugAllergyWithCodes'}?searchstr=${searchstr}`);
  }

  GetPatCCDAAllergies(patId: number, type: string,): Observable<CCDAAllergies[]> {
    return this.http.get<CCDAAllergies[]>(`${configuration.clinicapiUrl + 'Encounter/CCDAPatAllergy'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&type=${type}&&patId=${patId}`);
  }

  // Add allergy to patient encounter
  SaveCCDAAllergyInfo(allergyDetailsInfo: IAllergies[], encId: string): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(allergyDetailsInfo),
      EncounterId: encId
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/CCDAAllergies'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facId=${sessionStorage.getItem("FacilityId")}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetPatCCDAMedication(patId: number, type: string,): Observable<CCDAPatientMedication[]> {
    return this.http.get<CCDAPatientMedication[]>(`${configuration.clinicapiUrl + 'Encounter/CCDAPatMedication'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&type=${type}&&patId=${patId}`);
  }

  // Add allergy to patient encounter
  SaveCCDAMedicationInfo(medicationDetailsInfo: CCDAPatientMedication[], encId: string): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(medicationDetailsInfo),
      EncounterId: encId
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/CCDAPatMedication'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facId=${sessionStorage.getItem("FacilityId")}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //allergy Snomed 
  getAllergySnomedSearch(searchstr: string): Observable<IAllergySnomed[]> {
    return this.http.get<IAllergySnomed[]>(`${configuration.clinicapiUrl + 'Encounter/AllergiesSnomedInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&searchstr=${searchstr}`);
  }

  getDiscussionsACData(encounterId: string): Observable<ICSSubcategeories[]> {
    return this.http.get<ICSSubcategeories[]>(`${configuration.clinicapiUrl + 'Encounter/discussionACInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encounterId=${encounterId}`);
  }
}
